import Login from './Login';

export default Login;



// WEBPACK FOOTER //
// ./src/containers/Login/index.js